import React from "react";
import "../hooks/useBreakpoints";
import { useBreakpoints } from "../hooks/useBreakpoints";
import HeaderDesktop from "../components/HeaderDesktop";
import Header from "../components/Header";
import FooterContent from "../components/FooterContent";

const BlueLayout = ({ children }) => {
  const { lg } = useBreakpoints();
  return (
    <div className="flex flex-col min-h-screen">
      {lg ? (
        <HeaderDesktop />
      ) : (
        <Header />
      )}
      <main className="flex-grow">
        {children}
      </main>
      <FooterContent />
    </div>
  );
};

export default BlueLayout;
